import React, { useState, useEffect } from 'react';
import api from '../api';
import "./estilodashuser.css";

const ListarLicencas = ({ userId }) => {
  const [cliente, setCliente] = useState(null);
  const [planos, setPlanos] = useState([]);
  const [licencas, setLicencas] = useState([]);

  const [mensagem, setMensagem] = useState('');
  const [tipoMensagem, setTipoMensagem] = useState(''); // 'sucesso' | 'erro'
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (userId) {
      carregarDados();
    }
  }, [userId]);

  const carregarDados = async () => {
    try {
      setCarregando(true);
      setMensagem('');
      setTipoMensagem('');

      const [respCliente, respLicencas, respPlanos] = await Promise.all([
        api.get(`/api/clientes/${userId}`),
        api.get('/api/licencas'),
        api.get('/api/planos-ativos'),
      ]);

      setCliente(respCliente.data);

      const todasLicencas = respLicencas.data || [];
      const licencasDoCliente = todasLicencas
        .filter((lic) => lic.id_cliente === userId)
        .map((lic) => ({
          ...lic,
          status: Number(lic.status),
        }));

      setLicencas(licencasDoCliente);
      setPlanos(respPlanos.data || []);
    } catch (error) {
      console.error('Erro ao carregar licenças do usuário:', error);
      setMensagem('Erro ao carregar licenças. Tente novamente mais tarde.');
      setTipoMensagem('erro');
    } finally {
      setCarregando(false);
    }
  };

  const obterResumoSlots = () => {
    if (!cliente) {
      return {
        planoNome: '—',
        slotsContratados: 0,
        licencasAtivas: 0,
        slotsDisponiveis: 0,
      };
    }

    const slotsContratados =
      cliente.slots_contratados != null
        ? Number(cliente.slots_contratados)
        : 2;

    const licAtivas = licencas.filter((l) => l.status === 1).length;

    const plano = planos.find((p) => p.id === cliente.plano_id);
    const planoNome = plano ? plano.nome : 'Plano padrão';

    const slotsDisponiveis = Math.max(0, slotsContratados - licAtivas);

    return {
      planoNome,
      slotsContratados,
      licencasAtivas: licAtivas,
      slotsDisponiveis,
    };
  };

  const { planoNome, slotsContratados, licencasAtivas, slotsDisponiveis } =
    obterResumoSlots();

  const handleRemoverLicenca = async (id) => {
    const confirmar = window.confirm(
      'Tem certeza que deseja remover esta licença?'
    );
    if (!confirmar) return;

    try {
      await api.delete(`/api/licencas/${id}`);
      setLicencas((prev) => prev.filter((l) => l.id !== id));
      setMensagem('Licença removida com sucesso.');
      setTipoMensagem('sucesso');
    } catch (error) {
      console.error('Erro ao remover licença:', error);
      setMensagem('Erro ao remover licença. Tente novamente.');
      setTipoMensagem('erro');
    }
  };

  return (
    <div className="lic-page">
      <div className="lic-card">
        <div className="lic-header">
          <div className="lic-title">
            <span className="lic-ico">📜</span>
            <div>
              <h3 className="lic-h3">Minhas Licenças</h3>
              <div className="lic-subtitle">
                Aqui você pode remover uma licença para trocar a conta do MT5.
              </div>
            </div>
          </div>

          <button type="button" className="lic-btn-outline" onClick={carregarDados}>
            Recarregar
          </button>
        </div>

        <div className="lic-kpis">
          <div className="lic-kpi">
            <div className="lic-kpi-label">Plano</div>
            <div className="lic-kpi-value">{planoNome}</div>
          </div>
          <div className="lic-kpi">
            <div className="lic-kpi-label">Slots contratados</div>
            <div className="lic-kpi-value">{slotsContratados}</div>
          </div>
          <div className="lic-kpi">
            <div className="lic-kpi-label">Licenças ativas</div>
            <div className="lic-kpi-value">{licencasAtivas}</div>
          </div>
          <div className="lic-kpi">
            <div className="lic-kpi-label">Disponíveis</div>
            <div className="lic-kpi-value">{slotsDisponiveis}</div>
          </div>
        </div>

        {mensagem && (
          <div
            className={
              tipoMensagem === 'erro'
                ? 'alert-box alert-error'
                : 'alert-box alert-success'
            }
          >
            {mensagem}
          </div>
        )}

        {carregando && <p className="lic-loading">Carregando licenças...</p>}

        <div className="lic-table-wrap">
          <table className="licencas-table lic-table">
            <thead>
              <tr>
                <th>Número da Conta</th>
                <th>Chave</th>
                <th>Tipo</th>
                <th>Status</th>
                <th style={{ width: 140 }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {licencas.length > 0 ? (
                licencas.map((licenca) => (
                  <tr key={licenca.id}>
                    <td className="lic-mono">{licenca.conta}</td>
                    <td className="lic-mono lic-truncate" title={licenca.lkey}>
                      {licenca.lkey}
                    </td>
                    <td>{licenca.tipo}</td>
                    <td>
                      <span
                        className={
                          licenca.status === 1
                            ? 'lic-badge lic-badge-ok'
                            : 'lic-badge lic-badge-off'
                        }
                      >
                        {licenca.status === 1 ? 'Ativa' : 'Inativa'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-remover lic-btn-danger"
                        onClick={() => handleRemoverLicenca(licenca.id)}
                      >
                        Remover
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center' }}>
                    Nenhuma licença encontrada.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <p className="lic-footnote">
          * Ao remover uma licença, você libera o slot para ativar em outra conta.
        </p>
      </div>
    </div>
  );
};

export default ListarLicencas;
